var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "180px",
    width: "180px",
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-71.68 -71.68 655.36 655.36",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 1.024
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500.5,362.4c0-56.8-46.2-103.1-103.1-103.1s-103.1,46.2-103.1,103.1s46.2,103.1,103.1,103.1S500.5,419.3,500.5,362.4z M397.4,441c-43.3,0-78.6-35.3-78.6-78.6s35.3-78.6,78.6-78.6s78.6,35.3,78.6,78.6S440.7,441,397.4,441z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.9,325.9c-4.6-5-12.3-5.3-17.3-0.8c-5,4.6-5.4,12.3-0.8,17.3l7.1,7.8h-51.1c-6.8,0-12.3,5.5-12.3,12.3 s5.5,12.3,12.3,12.3h51.1l-7.1,7.8c-4.6,5-4.2,12.7,0.8,17.3c2.3,2.1,5.3,3.2,8.3,3.2c3.3,0,6.6-1.3,9.1-4l25.8-28.3 c4.3-4.7,4.3-11.8,0-16.5L420.9,325.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3,103.1H211c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h114.4c6.8,0,12.3-5.5,12.3-12.3S332.1,103.1,325.3,103.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 115.4,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,216.4c-6.8,0-12.3,5.5-12.3,12.3c0,6.8,5.5,12.3,12.3,12.3h114.4c6.8,0,12.3-5.5,12.3-12.3c0-6.8-5.5-12.3-12.3-12.3 H211z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 228.7,
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,342.2c0,37.9,30.8,68.7,68.7,68.7h184.6c6.8,0,12.3-5.5,12.3-12.3c0-6.8-5.5-12.3-12.3-12.3H80.2 c-24.4,0-44.2-19.8-44.2-44.6c0-24.4,19.8-44.2,44.2-44.2h205.3c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H80.2 c-24.4,0-44.2-19.8-44.2-44.6c0-24.4,19.8-44.2,44.2-44.2h269.5c24.4,0,44.2,19.8,44.2,44.6c0,6.8,5.5,12,12.3,12 s12.3-5.7,12.3-12.5c0-23.3-11.7-43.9-29.5-56.3c17.8-12.4,29.5-32.9,29.5-56.2v-1c0-37.7-30.7-68.4-68.4-68.4h-270 c-37.7,0-68.4,30.7-68.4,68.4v1c0,23.3,11.7,43.9,29.6,56.2c-17.8,12.5-29.6,33.2-29.6,56.8c0,23.4,11.8,44,29.6,56.4 C23.3,297.8,11.5,318.5,11.5,342.2z M79.9,159.8c-24.2,0-43.9-19.7-43.9-43.9v-1C36,90.7,55.7,71,79.9,71h270 c24.2,0,43.9,19.7,43.9,43.9v1c0,24.2-19.7,43.9-43.9,43.9h-0.3H80.2H79.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,329.7c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h51.8c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3H211z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.5,
    cy: 342,
    r: 13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetSettings);
export default __webpack_public_path__ + "static/media/assetSettings.50ee258d0d361671d58031d774feae3e.svg";
export { ForwardRef as ReactComponent };